import { DefaultState } from '@src/redux/types'

import { INTRO_VIDEOS } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defautltState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [INTRO_VIDEOS]: DefaultState<`${typeof API.VIDEO_TUTORIAL}`, 'get'>
} = () => ({
  [INTRO_VIDEOS]: defautltState(),
})
